module.exports = __webpack_public_path__ + "static/media/ic_LCD_green.5276b747.svg";